const defaultSearchConfiguration = {
    _searchable: true,
    email: { _searchable: true, _score: 500 },
    firstName: { _searchable: true, _score: 400 },
    lastName: { _searchable: true, _score: 400 },
    customer: {
        _searchable: true,
        firstName: { _searchable: true, _score: 200 },
        lastName: { _searchable: true, _score: 200 },
        customerNumber: { _searchable: true, _score: 150 },
        email: { _searchable: true, _score: 150 },
    },
};

export default defaultSearchConfiguration;